import React from 'react';
import PropTypes from 'prop-types';
import dotProp from 'dot-prop';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import {clone, EmptyFunc, isNoU} from "utils/DBUtils";
import {makeFormValidator} from "utils/forms";

export const formDataManager = (initialData, config) => {
    const formValidator = makeFormValidator(config);

    // Gather some metadata for image editing
    // Will only send save request to api for fields that are actually in the edit form
    const fieldsToSave = config ? config.fields.filter(field => field.type !== 'hidden').map(field => field.name) : null;

    return (Component) => {
        let comp = class extends React.Component {
            constructor(props) {
                super(props);
                this.state = this.initState(props);
            }

            componentWillReceiveProps(nextProps) {
                // update data if didn't previously have data (checking for empty object as well as null/undef)
                let newData = isEmpty(this.props.data) && !isEmpty(nextProps.data);

                // or if both datas exist with ids, and the ids are not equal
                let changedData = !isNoU(this.props.data) && !isNoU(nextProps.data)
                    && !isNoU(this.props.data.id) && !isNoU(nextProps.data.id)
                    && this.props.data.id !== nextProps.data.id;

                if (newData || changedData) {
                    this.setState(this.initState(nextProps));
                }
            }

            initState(props) {
                // Treat props data as data that should always be included
                let presetData = props.data || {};
                let data = Object.assign(clone(initialData), presetData);
                return {
                    data: data,
                    errors: {},
                    showErrors: false
                };
            }

            onValueChanged = (resourcePath, fieldPath, value) => {
                let newState = clone(this.state);
                let joinPath = fieldPath.join('.');
                dotProp.set(newState.data, joinPath, value);
                // Value changed means it passed validation from valueChangedValidator HOC
                // Possible improvement is to have errors solely controlled by this HOC
                delete newState.errors[joinPath];
                this.setState(newState);
            };

            onValidationError = (resourcePath, fieldPath, value, errors) => {
                let newState = clone(this.state);
                newState.errors[fieldPath.join('.')] = errors;
                this.setState(newState);
            };

            reset = () => {
                this.setState(this.initState(this.props));
            };

            saveData = () => {
                let dataToSave = {};

                let errors = formValidator(this.state.data);

                // Only save fields if they have changed from the original given value
                // If fieldsToSave is not specified, save all fields in data
              //  if (isNoU(fieldsToSave)) {
                    dataToSave = clone(this.state.data);
                // } else {
                //     // else only save specified fields, ignoring ones that haven't changed
                //     for (let field of fieldsToSave) {
                //         let value = this.state.data[field];
                //         // Skip if value hasn't changed
                //         if (this.props.onlySaveUnchanged && this.props.data && value === this.props.data[field]) {
                //             continue;
                //         }
                //         dataToSave[field] = value;
                //     }
                // }

                // Errors is a map, so check key count to see if there are any
                if (Object.keys(errors).length > 0) {
                    this.setState({
                        errors: errors,
                        showErrors: true
                    });
                    return;
                }

                // Check dataToSave key count to see if there are any changes
                // Send null to represent no data to save
                if (Object.keys(dataToSave).length === 0) {
                    this.props.onSaveData(null);
                    return;
                }

                if (this.props.data) {
                    dataToSave.id = this.props.data.id;
                }

                this.props.onSaveData(dataToSave);
            };

            render() {
                // Ignore all props in this components propTypes
                let childProps = omit(this.props, "data", "onSaveData");
                return (
                    <Component {...childProps}
                               formData={this.state.data}
                               reset={this.reset}
                               submit={this.saveData}
                               showErrors={this.state.showErrors}
                               errors={this.state.errors}
                               hasErrors={Object.keys(this.state.errors).length > 0}
                               onValueChanged={this.onValueChanged}
                               onValidationError={this.onValidationError}/>
                );
            }
        };

        comp.propTypes = {
            onSaveData: PropTypes.func,
            data: PropTypes.any,
            onlySaveUnchanged: PropTypes.bool
        };

        comp.defaultProps = {
            onSaveData: EmptyFunc,
            onlySaveUnchanged: true
        };

        comp.displayName = `formDataManager(${Component.name})`;

        return comp;
    };
};



// WEBPACK FOOTER //
// ./public/hoc/formDataManager.js